import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const TeamRankContext = createContext<{
  params?: Routing.TeamRankParams
}>({})

export { TeamRankContext }
